/**
 * Request header the web client sends while a staff member is viewing the app
 * as another user. The API honors it only after checking that the signed-in
 * user may impersonate the named user (see services/auth/impersonation.ts).
 */
export const IMPERSONATE_USER_HEADER = "x-impersonate-user-id";

/** Which half of the app the impersonated user normally signs in to. */
export enum ImpersonationExperience {
  Organization = "organization",
  Provider = "provider",
}
